module.exports = __webpack_public_path__ + "templates-59e97cd7/template-7-2x-0fa063e00a1cbd689dcd24133b083cb5.jpg";